const VIEW_BOX_MOVE_AMOUNT = 50;

export {
    VIEW_BOX_MOVE_AMOUNT,
};
